<template>
  <div class="stagiairesListWrapper">
    <BasicCard
      v-for="(stagiaire, key) in stagiairesList"
      :key
      :title="stagiaire.prenom + ' ' + stagiaire.nom"
      :avatar="{ type: 'name', name: stagiaire.prenom + ' ' + stagiaire.nom }"
    />
    <BasicButton
      v-if="listeStagiaires.length! > 2"
      @click="showFullStagiairesList = !showFullStagiairesList"
      variant="outlined"
      :label="!showFullStagiairesList ? 'Déployer la liste' : 'Réduire la liste'"
      iconRight
      :iconName="!showFullStagiairesList ? 'arrow-down' : 'arrow-up'"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref, computed } from 'vue'
  import type { StagiaireDTO } from '@/features/api/extranet/dto/Dossier/Synthese'

  const props = defineProps<{
    listeStagiaires: StagiaireDTO[]
    nombreDeListes: number
  }>()

  const showFullStagiairesList = ref(false)

  const stagiairesList = computed(() => {
    if (props.listeStagiaires.length! > 2 && !showFullStagiairesList.value) {
      return props.nombreDeListes > 1 ? props.listeStagiaires.slice(0, 1) : props.listeStagiaires.slice(0, 2)
    }
    return props.listeStagiaires
  })
</script>

<style lang="less" scoped>
  .stagiairesListWrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
</style>
